import React from 'react';

import { Query } from "react-apollo";

import AllDataStreamsQuery from 'GraphQueries/DataStreams/AllQuery';
import DataStreamSubscription from 'GraphQueries/DataStreams/Subscription';

import DatalakeExplorer from 'Components/Presentation/Datalake/DatalakeExplorer'

const fieldQuery = ['format,lastUpdated'];

class DatalakeIndexContainer extends React.Component {
    render() {
        return (
            <Query query={AllDataStreamsQuery(fieldQuery)}>
                {
                    ({ subscribeToMore, loading, error, data }) =>
                        <DatalakeExplorer loading={loading} dataStreams={data.listDataStreams} />
                }
            </Query>)
    }
}

export default DatalakeIndexContainer;


// WEBPACK FOOTER //
// ./src/Components/Containers/Datalake/Index.js